import React from "react";
const NavigateData = [
  {
    title: "الصفحة الرئيسية",
    link: "/",
  },
  /* {
    title: "السيرة الذاتية",
    link: "/portfolio",
  }, */
  {
    title: "الحملة الاعلامية",
    link: "/media",
  },
  {
    title: "تواصل معنا",
    link: "/contactus",
  },
];
function NavigateButtom() {
  return (
    <div className="text-center mt-3 d-flex justify-content-center align-items-center  flex-wrap row p-0 m-0">
      {NavigateData.map((item, index) => {
        return (
          <a
            key={index}
            href={item.link}
            className="mx-3 text-center btn btn-outline-dark col-12 col-md-3 col-lg-2 my-2"
          >
            {item.title}
          </a>
        );
      })}
    </div>
  );
}

export default NavigateButtom;
